import { request } from './helpers/request'

export const loadInvitation = (data) =>
  request({
    method: 'GET',
    url: `/users/invitation/accept/${data.invitationToken}`,
  }).then((response) => {
    if (response.status === 200) {
      return Promise.resolve(response.data)
    }

    return Promise.reject(new Error())
  })
